import type { AnalyticsColumn, AnalyticsObject } from './schema';

/**
 * Reads a column from a JSON row. Rows use System.Text.Json camelCase names; a case-insensitive
 * lookup covers any naming edge case.
 */
export function readValue(row: object, column: AnalyticsColumn): unknown {
  const record = row as Record<string, unknown>;
  if (column.jsonKey in record) return record[column.jsonKey];
  const lower = column.name.toLowerCase();
  const key = Object.keys(record).find((candidate) => candidate.toLowerCase() === lower);
  return key === undefined ? undefined : record[key];
}

/** Display text for a primitive JSON value. */
export function valueText(value: unknown): string {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return value === null || value === undefined ? '' : JSON.stringify(value);
}

/** The row's currency code (Stripe `Currency` column), for showing `…Minor` amounts as money. */
export function rowCurrency(object: AnalyticsObject, row: object): string | null {
  const column = object.columns.find((candidate) => candidate.name === 'Currency');
  const value = column ? readValue(row, column) : null;
  return typeof value === 'string' && value ? value : null;
}
